import React from 'react'
import { connect } from 'react-redux'
// import { API } from "../../../../API";
import DetailsHolder from '../DetailsHolder'
// import JobBoardComponent from '../../../Bookings2/JobBoardComponent'
import CollegeJobListContents from '../../../Bookings2/CollegeJobListContents';
import CollegeJobListMain from '../../../Bookings2/CollegeJobListMain';

const CollegeDetailJobs = ({ college, user }) => {

  return (
    <DetailsHolder college={college} activePath='/CollegeDetailJobs'>
      {/* <CollegeJobListContents
        user={user}
        institution={college.institution}
        campuses={college.campuses}
        classes={college.classes}
        isViewAsAdmin
      /> */}

      <CollegeJobListMain
        user={user}
        institution={college.institution}
        campuses={college.campuses}
        classes={college.classes}
        isViewAsAdmin
        customer={college.user}
      />
    </DetailsHolder>
  )
}

function mapStateToProps(state) {
  return {
    college: state.admin.college_details,
    user: state.user.user
  }
}

export default connect(mapStateToProps)(CollegeDetailJobs)
